export const useCashierOptions = () => {
  const { data, isFetching } = useCashiers()
  const options = computed(
    () =>
      data.value?.map((cashier) => ({
        value: cashier.id,
        label: cashier.username,
      })) || []
  )
  return {
    options: options,
    isFetching: readonly(isFetching),
    getLabelForValue: (value: string) =>
      computed(
        () =>
          options.value.find(
            (option) => option.value === value
          )?.label || ""
      ),
  }
}
